import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import SecretForm from '@/forms/SecretForm';
import { SecretFormValues } from '@/forms/SecretForm/types';
import SecretRepository from '@/repositories/SecretRepository';
import mapAxiosErrorMessages from '@/utils/mapAxiosErrorMessages';

import { Props } from './types';

const CreateSecretForm = ({
  entity_id,
  entity_type,
  initialValues,
  onSuccess,
  schema,
  secret_type_slug
}: Props) => {
  const { addMessage } = useContext(AppContext);
  const secretRepository = SecretRepository();
  const defaultValues = initialValues
    ? initialValues
    : {
        secretValue: ''
      };

  const createSecret = useMutation({
    mutationFn: (values: { [key: string]: string }) => {
      return secretRepository.createSecret({
        entity_type,
        entity_id,
        secret_type_slug,
        value: Object.values(values)[0]
      });
    },
    onSuccess: async () => {
      addMessage({ level: 'success', text: `${secret_type_slug} added successfully` });
      onSuccess?.();
    },
    onError: (error: AxiosError) => {
      addMessage(mapAxiosErrorMessages(error));
    }
  });

  const submitForm = (values: SecretFormValues) => {
    createSecret.mutate(schema ? schema.cast(values) : values);
  };

  return (
    <SecretForm
      initialValues={defaultValues}
      isSubmitting={createSecret.isPending}
      schema={schema}
      submitHandler={submitForm}
    />
  );
};

export default CreateSecretForm;
